import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    errors: []
  },

  getters: {
    last(state) {
      if (state.errors.length < 1) {
        return
      }

      const lastError = _.last(state.errors)
      return lastError.reason
    }
  },

  mutations: {
    add(state, reason) {
      state.errors.push({reason: reason})
    }
  },

  actions: {
    add({commit}, reason) {
      commit('add', reason)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/errors.js